import template from './batchErrors.html';
import controller from './batchErrors.controller';

let batchErrorsComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default batchErrorsComponent;



// WEBPACK FOOTER //
// ./app/components/batchErrors/batchErrors.component.js